let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLVjt")).then(() => parcelRequire('dL0gi'));